import { evalCondition } from 'mailup-react-helpers'

import { type LabelValuePair } from 'Types/common'

import getIntl from 'Helpers/intl'
import { FilterType } from 'Types/beFiltersApi'

import { routesAccessConditions } from 'src/config/config'

export const getFilterTypes = (): Array<LabelValuePair<FilterType>> => {
  const intl = getIntl()

  const result = [
    (evalCondition(routesAccessConditions.profile) as boolean)
      ? {
          label: intl.formatMessage({
            id: 'Load.FiltersList.AnagraphicFilter',
          }),
          value: FilterType.Anagraphic,
        }
      : undefined,
    (evalCondition(routesAccessConditions.activity) as boolean)
      ? {
          label: intl.formatMessage({ id: 'Load.FiltersList.ActivityFilter' }),
          value: FilterType.Activity,
        }
      : undefined,
    (evalCondition(routesAccessConditions.engagement) as boolean)
      ? {
          label: intl.formatMessage({
            id: 'Load.FiltersList.EngagementFilter',
          }),
          value: FilterType.Engagement,
        }
      : undefined,
    (evalCondition(routesAccessConditions.geolocation) as boolean)
      ? {
          label: intl.formatMessage({
            id: 'Load.FiltersList.GeolocationFilter',
          }),
          value: FilterType.Geolocation,
        }
      : undefined,
    (evalCondition(routesAccessConditions.device) as boolean)
      ? {
          label: intl.formatMessage({ id: 'Load.FiltersList.DeviceFilter' }),
          value: FilterType.Device,
        }
      : undefined,
    (evalCondition(routesAccessConditions.combinedFilterForm) as boolean)
      ? {
          label: intl.formatMessage({ id: 'Load.Filters.Tracking' }),
          value: FilterType.Tracking,
        }
      : undefined,
    (evalCondition(routesAccessConditions.combinedFilterForm) as boolean)
      ? {
          label: intl.formatMessage({ id: 'Load.FiltersList.MultiTypeFilter' }),
          value: FilterType.MultiType,
        }
      : undefined,
  ]

  return result.filter((o) => o !== undefined)
}
